export const PANOPTIC_APP_LAUNCHER_TEST_IDS = {
  root: 'panoptic-web-067-app-launcher',
  button: 'panoptic-web-067-app-launcher-button',
  panel: 'panoptic-web-067-app-launcher-panel',
  backdrop: 'panoptic-web-067-app-launcher-backdrop',
  cameras: 'panoptic-web-067-tile-cameras',
  frigateConfig: 'panoptic-web-067-tile-frigate-config',
  panoptic: 'panoptic-web-067-tile-panoptic',
};

const normalizePanopticServiceOrigin = (value) => String(value || 'http://192.168.55.7:8080').replace(/\/$/, '');

export const getPanopticLauncherLinks = (serviceOrigin = process.env.REACT_APP_PANOPTES_URL) => {
  const origin = normalizePanopticServiceOrigin(serviceOrigin);
  return [
    { label: 'Cameras', href: `${origin}/cameras`, testId: PANOPTIC_APP_LAUNCHER_TEST_IDS.cameras },
    { label: 'Frigate Config', href: `${origin}/frigate-config`, testId: PANOPTIC_APP_LAUNCHER_TEST_IDS.frigateConfig },
    { label: 'PanOptic', href: '/app/panoptic', testId: PANOPTIC_APP_LAUNCHER_TEST_IDS.panoptic, current: true },
  ];
};
